<!-- Use this custom icon component for a TVDecoder.

It will display an icon that matches the TVFormat of that decoder.

-->

<template>
  <span
    :title="tooltip"
    style="position: relative"
  >
    <v-icon
      style="border-radius: 0"
      :color="color"
      :large="large"
      :class="{'custom-large': large}"
      v-text="iconText"
    />
    <v-icon
      v-if="tvdecoder.is_menu_player"
      :color="color"
      class="menu"
      style="position: absolute; left: 0; top: 0"
      :style="{
        transform: menuPlayerIconTransform,
      }"
    >restaurant</v-icon>
  </span>
</template>

<script>
export default {
  props: {
    /**
     * We can also pass a TVSpot here, as long as it has a .tvformat it
     * will affect which icon is used (although e.g. the slave icon
     * variants will only be chosen for a TVDecoder).
     */
    tvdecoder: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: null,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    menuPlayerIconTransform() {
      let translateX = 0;
      let translateY = 0;
      let scale = 0.75;

      if (!this.large) {
        translateY = 1;
        scale = 0.55;
      }

      if (this.isPortraitFormat) {
        if (!this.large) {
          translateX = 0.25;
        }
        scale *= 0.9;
      }

      return `translateX(${translateX}px) translateY(${translateY}px) scale(${scale})`;
    },
    tooltip() {
      let text =
        this.$t('tv') +
        (this.tvdecoder.tvformat ? ': ' + this.tvdecoder.tvformat.name : '');
      if (this.tvdecoder.is_menu_player) {
        text += ' ' + this.$t('menuTVDecoderIsMenuPlayer');
      }
      return text;
    },
    hasNoFormat() {
      return !this.tvdecoder.tvformat;
    },
    isLandscapeFormat() {
      return (
        this.tvdecoder.tvformat &&
        this.tvdecoder.tvformat.aspect_ratio == 16 / 9
      );
    },
    isPortraitFormat() {
      return (
        this.tvdecoder.tvformat &&
        this.tvdecoder.tvformat.aspect_ratio == 9 / 16
      );
    },
    isStretchFormat() {
      return (
        this.tvdecoder.tvformat &&
        this.tvdecoder.tvformat.aspect_ratio == 32 / 9
      );
    },
    isSpecialFormat() {
      return (
        !this.hasNoFormat &&
        !this.isLandscapeFormat &&
        !this.isPortraitFormat &&
        !this.isStretchFormat
      );
    },
    hasSlaves() {
      return (
        this.tvdecoder.slave_decoder_serials_and_descriptions &&
        this.tvdecoder.slave_decoder_serials_and_descriptions.length > 0
      );
    },
    iconText() {
      if (this.hasNoFormat || this.isLandscapeFormat || this.isStretchFormat) {
        return this.hasSlaves
          ? '$vuetify.icons.tv_landscape_slaves'
          : '$vuetify.icons.tv_landscape';
      } else if (this.isPortraitFormat) {
        return this.hasSlaves
          ? '$vuetify.icons.tv_portrait_slaves'
          : '$vuetify.icons.tv_portrait';
      } else {
        return '$vuetify.icons.tv_special';
      }
    },
  },
};
</script>

<style scoped>
.custom-large {
  /* Builtin medium is 24px, large is 36px, which equals x 1.5 */
  transform: scale(1.5);
}
</style>



// WEBPACK FOOTER //
// src/components/IconTvDecoder.vue